import v from "./_assignValue.js";
import h from "./_baseAssignValue.js";
function x(a, r, i, d) {
  var l = !i;
  i || (i = {});
  for (var g = -1, s = r.length; ++g < s; ) {
    var n = r[g], f = d ? d(i[n], a[n], n, i, a) : void 0;
    f === void 0 && (f = a[n]), l ? h(i, n, f) : v(i, n, f);
  }
  return i;
}
export {
  x as default
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/lodash-es@4.17.21/~/lodash-es/_copyObject.js
// module id = 251
// module chunks = 67